export type PayPalApproveOrderPayload = {
	success?: boolean;
	message?: string;
	pending?: boolean;
	data?: unknown;
};

export type PayPalApproveVerdict =
	| {kind: 'success'; pending: boolean}
	| {kind: 'failure'; message: string};

/**
 * Shopper verdict for PayPal card approve-order. Backend `success` is authoritative;
 * raw `captures[0]` in the payload must not override it.
 */
function resolvePayPalApproveVerdict({
	result,
	error,
	fallbackMessage,
}: {
	result: PayPalApproveOrderPayload | null | undefined;
	error: unknown;
	fallbackMessage: string;
}): PayPalApproveVerdict {
	if (error || !result) {
		return {kind: 'failure', message: fallbackMessage};
	}

	if (result.success === true) {
		return {kind: 'success', pending: result.pending === true};
	}

	const message = typeof result.message === 'string' && result.message.trim() !== ''
		? result.message
		: fallbackMessage;

	return {kind: 'failure', message};
}

/**
 * Matches Blocks: a late `cardFields.submit()` rejection is ignored after onApprove
 * has already settled the attempt (`submitPromiseRef.current` cleared). Native uses an
 * explicit settled flag with the same outcome.
 */
function shouldSurfaceSubmitRejection(approvalSettled: boolean): boolean {
	return !approvalSettled;
}

export {
	resolvePayPalApproveVerdict,
	shouldSurfaceSubmitRejection,
};
